import add from "./add";
import edit from "./edit";
import show from "./show";

export default {
  add: add,
  edit: edit,
  show: show,
};
